import { post, get, put, patch, remove, getFile } from "../../ApiService";
import { ApiUrl } from "../../ApiUrl";
import {
  GetEquipmentListParams,
  EquipmentType,
  GeneralParams,
} from "./types";

export const getEquipmentList = async (
  params: GetEquipmentListParams,
  region: number,
  project: any,
  site: number
) => {
  try {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append("page", params.page.toString());
    if (params.pageSize)
      queryParams.append("pageSize", params.pageSize.toString());
    if (params.orderBy)
      queryParams.append("order_by", params.orderBy.toString());
    if (params.search) queryParams.append("search", params.search);
    if (params.category) queryParams.append("category", params.category);
    if (params.model) queryParams.append("model", params.model);
    if (params.brand) queryParams.append("brand", params.brand);
    if (params.fuelType) queryParams.append("fuelType", params.fuelType);
    if (site) queryParams.append("site", site.toString());

    const queryString = queryParams.toString();
    const url = `${ApiUrl.equipmentModule.equipmentMaster}${
      queryString ? `?${queryString}` : ""
    }&region=${region}&project=${project}`;

    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getEquipmentMasterList =async (region:number, project:any, site:number)=>{
  try {
    const url = `${ApiUrl.equipmentModule.equipmentMasterData}?region=${region}&project=${project}&site=${site}`;
    const res = await get(url);
    return res.data;
  } catch (error: any) {
    return error.response;
  }
}
export const copyEquipmentMaster =async (payload:any,region:number)=>{
  try {
    const url = `${ApiUrl.equipmentModule.equipmentMasterCopy}?region=${region}`;
    const res = await post(url,payload);
    return res;
  } catch (error: any) {
    return error.response;
  }
}


export const getEquipmentById = async (id: number) => {
  try {
    const url = `${ApiUrl.equipmentModule.equipmentMasterById(id)}`;
    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const createEquipment = async (
  data: EquipmentType,
  region: number,
  project: any,
  site: number
) => {
  try {
    const url = `${ApiUrl.equipmentModule.equipmentMaster}?region=${region}&project=${project}&site=${site}`;
    const res = await post(url, data);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const updateEquipment = async (
  id: number,
  data: EquipmentType,
  region: number,
  project: any,
  site: number
) => {
  try {
    const url = `${ApiUrl.equipmentModule.equipmentMasterById(
      id
    )}?region=${region}&project=${project}&site=${site}`;
    const res = await put(url, data);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const deleteEquipment = async (
  id: number,
  region: number,
  project: any
) => {
  try {
    const url = `${ApiUrl.equipmentModule.equipmentMasterById(
      id
    )}?region=${region}&project=${project}`;
    const res = await remove(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getEquipmentTypes = async (region: number, project: any, site: any) => {
  try {
    const url = `${ApiUrl.equipmentModule.equpimentTypes}?region=${region}&project=${project}&site=${site}`;
    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getEquipmentCategories = async (region: number, project: any) => {
  try {
    const url = `${ApiUrl.equipmentModule.equpimentCategories}?region=${region}&project=${project}`;
    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getEquipmentBrands = async (region: number, project: any) => {
  try {
    const url = `${ApiUrl.equipmentModule.equipmentBrads}?region=${region}&project=${project}`;
    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getOffRoadReports = async (
  params: GeneralParams & { page?: number; pageSize?: number; search?: string; orderBy?: string },
  region: number,
  project: any
) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.startDate) queryParams.append("start_date", params.startDate);
    if (params.endDate) queryParams.append("end_date", params.endDate);
    if (params.page) queryParams.append("page", params.page.toString());
    if (params.pageSize) queryParams.append("pageSize", params.pageSize.toString());
    if (params.search) queryParams.append("search", params.search);
    if (params.orderBy) queryParams.append("order_by", params.orderBy);

    const queryString = queryParams.toString();
    const url = `${ApiUrl.equipmentModule.offRoadReports}${
      queryString ? `?${queryString}` : ""
    }&region=${region}&project=${project}`;
    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getMaterialTransportReports = async (
  params: GeneralParams & { search?: string },
  region: number,
  project: any,
  page: number,
  pageSize: number,
  orderBy: string
) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.startDate) queryParams.append("start_date", params.startDate);
    if (params.endDate) queryParams.append("end_date", params.endDate);
    if (params.search) queryParams.append("search", params.search);

    const queryString = queryParams.toString();
    const url = `${ApiUrl.equipmentModule.materialTransportReports}${
      queryString ? `?${queryString}` : ""
    }&region=${region}&project=${project}&page=${page}&pageSize=${pageSize}&order_by=${orderBy}`;
    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getSummaryReports = async (
  params: GeneralParams & { page?: number; pageSize?: number },
  region: number,
  project: any
) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.startDate) queryParams.append("start_date", params.startDate);
    if (params.endDate) queryParams.append("end_date", params.endDate);
    if (params.page) queryParams.append("page", params.page.toString());
    if (params.pageSize) queryParams.append("pageSize", params.pageSize.toString());

    const queryString = queryParams.toString();
    const url = `${ApiUrl.equipmentModule.summaryReports}${
      queryString ? `?${queryString}` : ""
    }&region=${region}&project=${project}`;
    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getEnvironmentReports = async (params: GeneralParams, region: number, project: any) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.startDate) queryParams.append('start_date', params.startDate);
    if (params.endDate) queryParams.append('end_date', params.endDate);

    const queryString = queryParams.toString();
    const url = `${ApiUrl.equipmentModule.environmentReports}${queryString ? `?${queryString}` : ''}&region=${region}&project=${project}`;
    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
}

export const downloadOffRoadReports = async (
  params: GeneralParams,
  region: number,
  project: any
) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.startDate) queryParams.append("start_date", params.startDate);
    if (params.endDate) queryParams.append("end_date", params.endDate);
    if (params.reportType) queryParams.append("report_type", params.reportType);
    if (params.search) queryParams.append("search", params.search);

    const queryString = queryParams.toString();
    const url = `${ApiUrl.equipmentModule.downloadOffRoadReports}${
      queryString ? `?${queryString}` : ""
    }&region=${region}&project=${project}`;

    const response = await getFile(url);

    if (response.status === 200) {
      // Get the filename from the Content-Disposition header, or use a default name
      const contentDisposition = response.headers["content-disposition"];
      const filename = contentDisposition
        ? contentDisposition.split("filename=")[1].replace(/["']/g, "")
        : "offroad-report.xlsx";

      // Use the response data directly as it's already a blob
      const blob = response.data;

      // Create a temporary link element
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = filename;

      // Append to the document, click it, and remove it
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      // Clean up the URL object
      window.URL.revokeObjectURL(downloadLink.href);

      return { success: true };
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error: any) {
    return error.response || error;
  }
};

export const downloadEquipmentListReports = async (
  params: GeneralParams,
  region: number,
  project: any,
  site: any
) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.startDate) queryParams.append("start_date", params.startDate);
    if (params.endDate) queryParams.append("end_date", params.endDate);

    const queryString = queryParams.toString();
    const url = `${ApiUrl.equipmentModule.downloadEquipmentListReports}${
      queryString ? `?${queryString}` : ""
    }&region=${region}&site=${site}`;

    const response = await getFile(url);

    if (response.status === 200) {
      // Get the filename from the Content-Disposition header, or use a default name
      const contentDisposition = response.headers["content-disposition"];
      const filename = contentDisposition
        ? contentDisposition.split("filename=")[1].replace(/["']/g, "")
        : "equipment-list-report.xlsx";

      // Use the response data directly as it's already a blob
      const blob = response.data;

      // Create a temporary link element
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = filename;

      // Append to the document, click it, and remove it
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      // Clean up the URL object
      window.URL.revokeObjectURL(downloadLink.href);

      return { success: true };
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error: any) {
    return error.response || error;
  }

};

export const approveEmission = async (id: number, region: number, project: any) => {
    
  try {
    const url = `${ApiUrl.equipmentModule.approveEmission}?region=${region}&project=${project}&id=${id}`;
    const res = await post(url, { id });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const rejectEmission = async (id: number, region: number, project: any) => {
  try {
    const url = `${ApiUrl.equipmentModule.rejectEmission}?region=${region}&project=${project}&id=${id}`;
    const res = await post(url, { id });
    return res;
  } catch (error: any) {
    return error.response;
  }
      
};
